import type { CommentFieldValue } from "@/shared/components/comment-field/use-comment-field";
import type { FieldValue } from "@/shared/types/workflow/workflow-form.types";
import { isRichTextValue } from "@/shared/utils/rich-text";

/**
 * Transforms a field value into a CommentFieldValue
 */
export function transformFieldValueToCommentValue(
  value: FieldValue,
): Partial<CommentFieldValue> {
  if (!value || typeof value !== "object") {
    return {
      content: undefined,
      attachment: undefined,
    };
  }

  let content: CommentFieldValue["content"] | undefined = undefined;
  if ("content" in value && isRichTextValue(value.content)) {
    content = value.content;
  }

  let attachment: CommentFieldValue["attachment"] = null;
  if ("attachment" in value && value.attachment instanceof File) {
    attachment = value.attachment;
  }

  return {
    content,
    attachment,
  };
}
